import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "manager-requests__reply-form" }

import { ref, watch } from 'vue';
import Textarea from 'primevue/textarea';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReplyForm',
  props: {
    loading: { type: Boolean },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const message = ref(props.modelValue);

// Синхронизация с родителем
watch(
  () => props.modelValue,
  (newVal) => {
    message.value = newVal;
  },
);

watch(message, (newVal) => {
  emit('update:modelValue', newVal);
});

__expose({
  clearMessage: () => {
    message.value = '';
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Textarea), {
      modelValue: message.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event)),
      rows: "5",
      autoResize: true,
      placeholder: "Введите ваш ответ...",
      disabled: __props.loading,
      style: {"width":"100%"}
    }, null, 8, ["modelValue", "disabled"])
  ]))
}
}

})